<template>
  <div>
    <!-- 商品备注 -->
    <el-dialog :title="title ? title : $t('message.boxRemarks')" :close-on-click-modal="false"
      :visible.sync="$parent.boxRemarkDialogVisible" width="520px" center>
      <div class="content">
        <el-input type="textarea" placeholder="请输入备注" v-model="boxRemarksData.y_remark" resize="none"
          v-if="userRoleStatus == 1" rows="7">
        </el-input>
        <el-input type="textarea" placeholder="请输入备注" v-model="boxRemarksData.p_remark" resize="none"
          v-else-if="userRoleStatus == 5" rows="7">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.boxRemarkDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    boxRemarksData: { type: Object },
    title: { type: String }
  },
  data() {
    return {
      userRoleStatus: localStorage.getItem("japanUserRoleStatus"),
    };
  },
  methods: {
    save() {
      if (this.userRoleStatus == 1) {
        this.$api.inspectionApi
          .updateYRemark(this.boxRemarksData)
          .then((res) => {
            this.$message.success(res.msg);
            this.$parent.boxRemarkDialogVisible = false;
            this.$parent.handleClick();
          });
      } else if (this.userRoleStatus == 5) {
        this.$api.inspectionApi
          .updatePRemark(this.boxRemarksData)
          .then((res) => {
            this.$message.success(res.msg);
            this.$parent.boxRemarkDialogVisible = false;
            this.$parent.handleClick();
          });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 0 15px;
}
</style>